import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    const hostname = typeof window === 'undefined' ? '' : window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      console.error(err);
    }
  });
